import isObject from '@/utils/isObject'
import isObjectEmpty from '@/utils/isObjectEmpty'
import ApiService from '@/services/apiService'
import formatDate from '@/utils/formatDate'
import toCurrency from '@/utils/toCurrency'

/**
 * Booking summary used in the final step of the form
 */
const state = {
	flyt: {},
	status: 'idle'
}

const getters = {
	hasSummary: (state) => !isObjectEmpty(state.flyt),
	hasReturn: (state, getters) => {
		let returnObj = state.flyt.return_flyt
		return (
			getters.hasSummary
			&& isObject(returnObj)
			&& !isObjectEmpty(returnObj)
		)
	},
	steps: (state) => state.flyt.steps,
	formattedDate: (state) => formatDate(state.flyt.date),
	formattedReturnDate: (state, getters) => getters.hasReturn
		? formatDate(state.flyt.return_flyt.date)
		: null,
	returnSteps: (state, getters) => getters.hasReturn
		? state.flyt.return_flyt.steps
		: null,
	aircraft: (state) => state.flyt.aircraft,
	totalCost: (state) => toCurrency(state.flyt.currency.iso_code, state.flyt.costs.aggregated_total_cost)
}

const mutations = {
	setSummary: (state, { flyt }) => state.flyt = flyt,
	clearSummary: (state) => state.flyt = {},
	statusIsIdle: (state) => state.status = 'idle',
	statusIsPending: (state) => state.status = 'pending',
	statusIsSuccess: (state) => state.status = 'success',
	statusIsError: (state) => state.status = 'error'
}

const actions = {
	/**
	 * If a UUID is present on the booking,
	 * fetch resulting summary from API.
	 */
	fetchSummary({ commit, rootState }) {
		const uuid = rootState.bookingForm.uuid
		if (!uuid) return

		commit('statusIsPending')
		ApiService.get(`bookings/get-details/${uuid}`)
			.then((response) => {
				commit('setSummary', response.data)
				commit('statusIsSuccess')
			})
			.catch(() => commit('statusIsError'))
			.then(() => commit('bookingForm/setStepLoading', null, { root: true }))
	},

	/**
	 * Submit final summary
	 */
	submitSummary({ commit, rootState }, payload) {
		const uuid = rootState.bookingForm.uuid
		if (!uuid) return

		// Set confirmation step to loading
		commit('bookingForm/setStepLoading', 4, { root: true })

		ApiService.post(`/bookings/confirm-flyt/${uuid}`, payload)
			.then(() => {
				commit('bookingForm/setStepLoading', null, { root: true })
			})
			.catch(response => console.log(response))
	},

	/**
	 * Reset all state back to intitial
	 */
	clearSummary({commit}) {
		commit('clearSummary')
		commit('statusIsIdle')
	}
}

export default { namespaced: true, state, getters, mutations, actions }
